import { createFileRoute } from "@tanstack/react-router";

/**
 * Layout route for /project/:projectId/* pages.
 *
 * This route exists to define the URL segment for TanStack Router's
 * file-based routing. It serves as the parent for all child routes
 * (business collections, solution folders, shared entity routes, etc.).
 *
 * This component does NOT render any UI or handle tab creation:
 * - UI is rendered by ProjectsHost in the root layout (keep-alive pattern)
 * - Tab creation for deep links is handled by RouterBridge and TabsStore
 * - The root layout skips <Outlet /> for project routes, so child route
 *   components defined here never actually mount
 *
 * See: src/routing/react/RouterBridge.tsx for deep link handling
 */
export const Route = createFileRoute("/project/$projectId")({
  component: () => null,
});
